import jwt from 'jsonwebtoken';

export const getAPIEndpoint = () => {
  // if (process.env.NODE_ENV === 'production') {
  // return 'https://tigercafe-demo.herokuapp.com/api/v1';
  // } else {
  return 'https://api.migholdingsltd.com/api/v1';
  // return 'http://192.168.2.179:8000/api/v1';
  // }

  // return 'http://192.168.0.104:3000/api/v1'

  // return 'https://tigercafe-demo.herokuapp.com/api/v1';
};

export const getSocketEndpoint = () => {
  // return 'https://tigercafe-demo.herokuapp.com';
  return 'https://api.migholdingsltd.com/api/v1';
  // return 'http://192.168.1.144:8000/api/v1/';
};

export const getAllOnlineUserEndpoint = () => {
  // return 'https://tigercafe-demo.herokuapp.com/api/onlineUsers';
  return 'https://api.migholdingsltd.com/api/v1/onlineUsers';
  // return 'http://192.168.1.144:8000/api/v1/onlineUsers';
};

export const rejectError = error => {
  let message = error.response.data.message || 'Ooops, something went wrong';
  if (error.response && error.response.data && error.response.data.errors) {
    message = error.response.data.errors.message;
  }

  return Promise.reject(message);
};

export const applyFilters = (url, filter) => {
  if (filter) {
    let filteredEntities = '';
    if (url.indexOf('?') === -1) {
      url += '?';
    } else {
      url += '&';
    }

    Object.keys(filter).forEach(key => {
      filteredEntities += `${key}=${filter[key]}&`;
    });

    if (filteredEntities.slice(-1) === '&') {
      filteredEntities = filteredEntities.slice(0, -1);
    }

    return url + filteredEntities;
  }

  return url;
};

export const processedLocation = location => {
  return location
    .toLowerCase()
    .replace(/[\s,]+/g, '')
    .trim();
};

export const checkTokenValidity = token => {
  if (token) {
    const decodedToekn = jwt.decode(token);

    return decodedToekn && decodedToekn.exp * 1000 > new Date().getTime();
  }

  return false;
};
